let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("laUKW")).then(() => parcelRequire('jGROW'));